@use '@/sass/variables';

.action {
  color: variables.$mint-green;
  background: transparent;
  border: 0;
  border-radius: 0;
  padding: 10px 0 5px 0;
  margin: 0;
  height: auto;
  line-height: 1;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  &:hover,
  &:focus,
  &:active {
    color: variables.$mint-green;
    background: transparent;
    background-image: none;
    border: 0;
    box-shadow: none;
    outline: 0;
  }
}
